<template>
  <div class="statistics-pie">
    <div class="statistics-pie__title">항목별 클릭 비율</div>
    <div class="statistics-pie__chart">
      <div>
        <ve-pie
          width="320px"
          height="240px"
          :judge-width="true"
          :resizeable="true"
          :legend-visible="false"
          :data="chartData"
          :settings="{
            dimension: 'type',
            metrics: 'value',
            radius: 70,
            offsetY: 130,
            itemStyle: {
              emphasis: {
                shadowBlur: 5,
                shadowColor: 'rgba(0, 0, 0, 0.2)',
              },
            },
          }"
        />
      </div>
      <div class="statistics-pie__chart-type">
        <ul>
          <li v-for="(item, index) in chartData.rows" :key="item.type">
            <div
              class="color-box"
              :style="`background-color: ${colorMap[index]}`"
            />
            <span>{{ item.type }}</span> {{ item.value }}%
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StatisticsPieChart",
  data: () => ({
    colorMap: ["#19d4ae", "#5ab1ef", "#fa6e86", "#ffb980"],
  }),
  props: {
    chartData: Object,
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.statistics-pie {
  padding: 24px;
  margin-top: 60px;
  border-radius: 10px;
  text-align: center;

  .color-box {
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  &__title {
    font-size: 15px;
    color: #595959;
  }

  &__chart {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

    &-type {
      margin-left: 24px;
      line-height: 2.4;
      font-size: 1.4rem;
      text-align: left;

      span {
        display: inline-block;
        width: 70px;
      }
    }
  }
}

@media (max-width: $min_layout) {
  .statistics-pie {
    padding: 24px 16px;

    &__chart {
      flex-direction: column;

      &-type {
        padding-top: 16px;
      }
    }
  }
}
</style>
